import { withDirectives as _withDirectives, vShow as _vShow, createVNode as _createVNode } from "vue";
/**
 * @author liaoyanhua
 * @fileoverview 赛事进程安排（赛程安排）- pc
 */
import { defineComponent, reactive } from 'vue';
// config
import { informationDateList, scPlanListPc } from '@/config/information';
// assets
import scTitleUrl from "@/assets/img/pc/sc-title.png";
import _ from "lodash";
export default defineComponent({
  name: 'RaceProcessPlan',
  setup() {
    const state = reactive({
      process: 1,
      // 赛事进度
      planDate: informationDateList[0].list // 排期 - 报名阶段
    });

    // 赛事进度切换
    function processChange(id) {
      state.process = id;
      informationDateList.forEach(item => {
        if (id === item.id) {
          state.planDate = item.list;
        }
      });
    }
    return () => {
      // 赛程安排 - 日程信息展示
      const planDateItem = _.map(state.planDate, item => {
        return _createVNode("div", {
          "class": "item-box"
        }, [_createVNode("div", {
          "class": "item-t"
        }, [_createVNode("div", {
          "class": "name-box"
        }, [_createVNode("span", {
          "class": "name",
          "innerHTML": item.name
        }, null)]), _createVNode("img", {
          "class": "bg",
          "src": require(`@/assets/img/m/sc-item-bg.png`)
        }, null)]), _createVNode("div", {
          "class": "item-b"
        }, [_createVNode("div", {
          "class": "text"
        }, [_createVNode("span", null, [item.date]), item.hour && _createVNode("span", null, [item.hour])])])]);
      });
      // 虚线进度条
      const divide = _.map(state.planDate, () => {
        return _createVNode("div", {
          "class": "divide-item"
        }, [_createVNode("span", null, null), _createVNode("a", null, null), _createVNode("span", null, null)]);
      });
      const planItem = _.map(scPlanListPc, item => {
        return _createVNode("img", {
          "class": "item",
          "src": require(`@/assets/img/${item.image}`)
        }, null);
      });
      return _createVNode("div", {
        "class": "pc-explain pc-information"
      }, [_createVNode("div", {
        "class": "sc-box",
        "id": "sc-box"
      }, [_createVNode("img", {
        "id": "schedule",
        "class": "title",
        "src": scTitleUrl
      }, null), _withDirectives(_createVNode("div", {
        "class": "btn-box"
      }, [_createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          processChange(1);
        },
        "src": require(`@/assets/img/m/sc-1${state.process === 1 ? "-act" : ""}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          processChange(2);
        },
        "src": require(`@/assets/img/m/sc-2${state.process === 2 ? "-act" : ""}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          processChange(3);
        },
        "src": require(`@/assets/img/m/sc-3${state.process === 3 ? "-act" : ""}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          processChange(4);
        },
        "src": require(`@/assets/img/m/sc-4${state.process === 4 ? "-act" : ""}.png`)
      }, null)]), [[_vShow, false]]), _withDirectives(_createVNode("div", {
        "class": "info-box"
      }, [_createVNode("div", {
        "class": "info-t"
      }, [_createVNode("div", {
        "class": "divide-b"
      }, [_createVNode("div", {
        "class": "inner"
      }, [divide])]), planDateItem])]), [[_vShow, false]]), _createVNode("div", {
        "class": "plan-wrap"
      }, [planItem])])]);
    };
  }
});